<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="h-full bg-white flex flex-col overflow-hidden">
    <div class="flex-1 overflow-y-auto">
      <div class="max-w-4xl mx-auto w-full p-8">
        <div class="space-y-6">
          <div>
            <h1 class="text-2xl font-bold text-gray-800 mb-2">{{ t('guide') }}</h1>
            <p class="text-sm text-gray-600">{{ t('guideSubtitle') }}</p>
          </div>

          <!-- Guide Content -->
          <div class="prose prose-sm max-w-none">
            <div class="space-y-4">
              <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p class="font-medium mb-2 text-gray-800">{{ t('basicVariables') }}</p>
                <p class="mb-2 text-gray-700">{{ t('basicVariablesDesc') }}</p>
                <code class="block bg-white px-3 py-2 rounded border border-blue-200 font-mono text-sm">Order number: {Order_number}</code>
              </div>

              <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <p class="font-medium mb-2 text-gray-800">{{ t('loopFieldsTitle') }}</p>
                <p class="mb-2 text-gray-700">{{ t('loopFieldsDesc') }}</p>
                <pre class="bg-white px-3 py-2 rounded border border-yellow-200 font-mono text-sm m-0 overflow-x-auto">{#Invoice_details}
  Product: {Product}, Qty: {QTY}
{/Invoice_details}</pre>
              </div>

              <div class="bg-green-50 border border-green-200 rounded-lg p-4">
                <p class="font-medium mb-2 text-gray-800">{{ t('nestedFieldsTitle') }}</p>
                <p class="mb-2 text-gray-700">{{ t('nestedFieldsDesc') }}</p>
                <code class="block bg-white px-3 py-2 rounded border border-green-200 font-mono text-sm">Customer city: {Customer.city}</code>
              </div>

              <div class="bg-purple-50 border border-purple-200 rounded-lg p-4">
                <p class="font-medium mb-2 text-gray-800">{{ t('conditionalsTitle') }}</p>
                <p class="mb-2 text-gray-700">{{ t('conditionalsDesc') }}</p>
                <pre class="bg-white px-3 py-2 rounded border border-purple-200 font-mono text-sm m-0 overflow-x-auto">{#if Status == "Completed"}
  ✅ Order completed
{/if}

{#if Priority != "Low"}
  ⚠️ Requires attention
{/if}

{#if Is_urgent == "true"}
  🚨 URGENT
{/if}</pre>
                <p class="mt-2 text-sm text-gray-600">{{ t('conditionalsHelp') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
